import { Button } from '@shared/widgets';
import { MouseEvent } from 'react';

const PHONE = '+420458965896';
const PHONE_FORMATTED = '+420-4589-65-896';

interface ErrorType {
  onAction: (e: MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const Error = (props: ErrorType) => {
  return (
    <div className='flex flex-col items-center gap-[56px] opacity-100 transition-opacity duration-300'>
      <section className='h-[444px] w-[498px]'>
        <h2 className='m-0 mb-9 p-0 text-center text-5xl leading-[48px] font-semibold text-[#000]'>Something went wrong</h2>
        <div>
          <p className='text-center text-xl leading-[36px] font-medium text-[#666] opacity-95'>Please contact our support team</p>
          <p className='text-center text-xl leading-[36px] font-medium text-[#666] opacity-95'>if you have any questions</p>
          <p className='text-center text-xl leading-[36px] font-medium text-[#666] opacity-95'>
            tel.:{' '}
            <a className='text-inherit no-underline' href={`tel:${PHONE}`}>
              {PHONE_FORMATTED}
            </a>
          </p>
        </div>
      </section>
      <div className='flex w-full items-stretch justify-center'>
        <Button className='!h-auto w-[75%] !p-6' onClick={() => props.onAction}>
          Try again
        </Button>
      </div>
    </div>
  );
};
